import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./Context/UserContext";
import { HomePageProvider } from "./Context/HomePageContext";
import { SelectedHomeTablePlayerProvider } from "./Context/SelectedHomeTablePlayerContext";
import { ThemeProvider } from "@mui/material/styles";
import { appTheme } from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <UserProvider>
        <HomePageProvider>
          <SelectedHomeTablePlayerProvider>
            <App />
          </SelectedHomeTablePlayerProvider>
        </HomePageProvider>
      </UserProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
